import useCountdown from "@/hooks/useCountdown";
import Amplitude from "@/shared/services/amplitude.service";
import {
  getCurrentURL,
  getReferrer,
  getScreenWidth,
} from "@/shared/utils/commons";
import { getFromLocal } from "@/shared/utils/storage.util";
import { usePathname, useSearchParams } from "next/navigation";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

interface PromotionStripProps {
  data: {
    type: string;
    text : string;
    endAfterHour: number;
    href: string
    amplitudeEvent: {
      eventName: string;
      eventProperties: { [key: string]: string };
    };
  };
  source?: "navbar";
}

export const PromotionStripUS: React.FC<PromotionStripProps> = ({
  data,
  source,
}) => {
  const { endAfterHour, href, amplitudeEvent, text } = data;
  const path = usePathname();
  const { hours, minutes, seconds } = useCountdown(path, endAfterHour);
  const [showStrip, setShowStrip] = useState(true);

  const params = useSearchParams();
  const gclid = params.get("gclid");
  const params_q = params.get("q");
  const router = useRouter();
  const url = router.query.page;
  const isWebinarRebeccaSchocker = url === "webinar-rebecca-schocker";

  useEffect(() => {  
    window.addEventListener("scroll", () => {
      if (scrollY < 1) {
        setShowStrip(true);
      } else {
        setShowStrip(false);
      }
    });
    return () => {
      setShowStrip(true);
    };
  }, []);

  if (!showStrip && source !== "navbar" && !isMobile) return null;

  const handleClick = () => {
    if (href === null || href === undefined) return;

    // let utmFields = getUTMFieldsFromLocalStorage();
    // utmFields["utm_content"] = gclid ? gclid : "autobookdemos";
    // const isUrlParams = new URLSearchParams(data.href).size;

    // const utmParams = stringifyUTMParams(utmFields);
    
      if (isWebinarRebeccaSchocker) {
        const scrollY = window.scrollY;
        if (scrollY === 0) {
          window.scrollTo({ top: 80 , behavior: 'smooth' });
        } else if (scrollY > 80) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        return;
      }
      
    

    let url = `${data.href}`;
    window.open(url, "_blank");

    new Amplitude().sendEvent({
      type: amplitudeEvent?.eventName,
      properties: {
        ...amplitudeEvent.eventProperties,
        current_url: getCurrentURL(),
        utm_params: getFromLocal("utmFields"),
        screen_width: getScreenWidth(),
        referrer: getReferrer(),
      } as { [key: string]: string | number },
    });
  };
  return (
    <div
      className={`${
        source === "navbar" ? "rounded-full" : ""
      } sticky top-[64px] flex cursor-pointer flex-col items-center justify-center gap-2 bg-green-2 p-3 text-center sm:flex-row sm:gap-3 md:top-[88px]`}
      onClick={handleClick}
    >
      <p className="text-title-16 font-semibold text-white">
        {text}
         {/* {preText ? preText : "Get"}  <span className="text-green-2"> {percentage}% off</span>  {postText ? postText : "on booking a demo today"} */}
      </p>
      <p className="rounded-full bg-[#FFF8D4] px-3 py-1.5 text-title-12 font-semibold text-purple-3">
        Offer ends in {hours}h {minutes}m {seconds}s
      </p>
    </div>
  );
};
